import getApi from '../../api/apisauceConfig'
import { Contact, ContactConfiguration } from '../../model/Contact'

export const updateContactConfiguration = (
  id: string,
  contactConfiguration: ContactConfiguration,
) => getApi().put<Contact>(`/contacts/${id}/user_contact_configuration`, contactConfiguration)
